// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  published: true,
  api: 'https://the-piano-workshop.firebaseio.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyAcnJ3XymLzXd6TOM-duBStpg0M357KInc',
    authDomain: 'the-piano-workshop.firebaseapp.com',
    databaseURL: 'https://the-piano-workshop.firebaseio.com',
    projectId: 'the-piano-workshop',
    storageBucket: 'the-piano-workshop.appspot.com',
    messagingSenderId: '91374613668',
    appId: '1:91374613668:web:992334263485cb72a72231',
    measurementId: 'G-QV0JCY1VRF'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
